import Layout from "./components/Layout";
import { useEffect, useState } from "react";
import Button from "./components/Button";
import Loading from "./components/Loading";
import { FcExport } from "react-icons/fc";
import { AlertError } from "./components/Alert";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./authContext";
import apiClient from "./apiClient";
// @ts-ignore
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx-js-style";
import { format } from "date-fns";

const range = (start: any, end: any) =>
  Array.from({ length: end - start }, (v, k) => k + start);
const inputClass =
  "px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";

function Report() {
  let navigate = useNavigate();
  const { userProfile } = useAuth();

  const [isLoading, setLoading] = useState(false);
  const [year, setYear] = useState("");
  const [rangeYears, setRangeYears] = useState([]);

  let reportMonthInit = [
    {
      sell_month: 1,
      month_name: "มกราคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 2,
      month_name: "กุมภาพันธ์",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 3,
      month_name: "มีนาคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 4,
      month_name: "เมษายน",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 5,
      month_name: "พฤษภาคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 6,
      month_name: "มิถุนายน",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 7,
      month_name: "กรกฎาคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 8,
      month_name: "สิงหาคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 9,
      month_name: "กันยายน",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 10,
      month_name: "ตุลาคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 11,
      month_name: "พฤศจิกายน",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
    {
      sell_month: 12,
      month_name: "ธันวาคม",
      sum_income: 0,
      sum_expense: 0,
      net_profit: 0,
    },
  ];

  const [reportMonths, setReportMonths] = useState(reportMonthInit);
  const [sumYearIncome, setSumYearIncome] = useState(0);
  const [sumYearExpense, setSumYearExpense] = useState(0);
  const [sumYearNetProfit, setSumYearNetProfit] = useState(0);

  useEffect(() => {
    const loadYears = async () => {
      try {
        const response = await apiClient.post("/v1/report/years");
        let data = response.data;
        let years = data.years;
        // @ts-ignore
        setRangeYears(range(years.MinYear + 543, years.MaxYear + 543));
      } catch (error) {
        console.log("error", error);
      }
    };
    loadYears();
  }, []);

  function convertToFormat(num: any) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function onChangeYear(e: any) {
    let val = e.target.value;
    setYear(val);
    if (val === "") {
      setReportMonths(reportMonthInit);
      setSumYearIncome(0);
      setSumYearExpense(0);
      setSumYearNetProfit(0);
      return;
    }
    setReportMonths(reportMonthInit);
    setLoading(true);
    setTimeout(() => {
      let data = { year: Number(val) - 543 };
      console.log(data);
      apiClient
        .post("/v1/reportByYear", data)
        .then((res) => {
          if (res.data.result === "success") {
            let reportMonthData = res.data.reportMonths;
            let sIncome = 0,
              sExpense = 0,
              sProfit = 0;
            let reportMonthNew = reportMonths.map((reportMonth) => {
              let tmp = reportMonthData.filter(
                (rm: any) =>
                  Number(rm.sell_month) === Number(reportMonth.sell_month),
              );
              if (tmp.length > 0) {
                sIncome += tmp[0].sum_income;
                sExpense += tmp[0].sum_expense;
                sProfit += tmp[0].net_profit;
                return { ...tmp[0], month_name: reportMonth.month_name };
              } else {
                return {
                  sell_month: reportMonth.sell_month,
                  month_name: reportMonth.month_name,
                  sum_income: 0,
                  sum_expense: 0,
                  net_profit: 0,
                };
              }
            });
            setReportMonths(reportMonthNew);
            setSumYearIncome(sIncome);
            setSumYearExpense(sExpense);
            setSumYearNetProfit(sProfit);
          }
        })
        .catch((error) => console.log("error:", error));
      setLoading(false);
    }, 1200);
  }

  function exportToExcel() {
    if (year === "") {
      AlertError("กรุณาเลือกปี");
      return;
    }
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    let curr = format(new Date(), "dd/MM/yyyy HH:mm:ss");
    let currFileName = format(new Date(), "yyyy-MM-dd");
    const title: any[] = [
      { A: "รายงานสรุปรายรับ/รายจ่ายปี " + year },
      { A: "ส่งออกเมื่อ : " + curr },
    ];
    let table1: any[] = [
      { A: "ลำดับ", B: "เดือน", C: "รวมรับ", D: "รวมจ่าย", E: "กำไรสุทธิ" },
    ];
    reportMonths.forEach((row) => {
      table1.push({
        A: row.sell_month,
        B: row.month_name,
        C: row.sum_income,
        D: row.sum_expense,
        E: row.net_profit,
      });
    });
    let summary = [
      {
        A: "รวม",
        B: "",
        C: sumYearIncome,
        D: sumYearExpense,
        E: sumYearNetProfit,
      },
    ];
    const reportData = [...title, ...table1, ...summary];
    const cellTable = {
      top: { style: "thin", color: { rgb: "000000" } },
      bottom: { style: "thin", color: { rgb: "000000" } },
      left: { style: "thin", color: { rgb: "000000" } },
      right: { style: "thin", color: { rgb: "000000" } },
    };
    setLoading(true);
    window.scrollTo(0, 0);
    setTimeout(() => {
      // prettier-ignore
      // @ts-expect-error xlsx-js-style supports origin but types don't
      const ws = XLSX.utils.json_to_sheet(reportData, { origin: "A2", skipHeader: true });

      let rangeTitle = { s: { r: 3, c: 0 }, e: { r: 3, c: 4 } };
      for (let R = rangeTitle.s.r; R <= rangeTitle.e.r; ++R) {
        for (let C = rangeTitle.s.c; C <= rangeTitle.e.c; ++C) {
          let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (!cell) continue;
          cell.s = {
            alignment: { horizontal: "center" },
            font: { bold: true },
            border: cellTable,
          };
        }
      }
      let rangeOrder = { s: { r: 4, c: 0 }, e: { r: 16, c: 0 } };
      for (let R = rangeOrder.s.r; R <= rangeOrder.e.r; ++R) {
        for (let C = rangeOrder.s.c; C <= rangeOrder.e.c; ++C) {
          let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (!cell) continue;
          cell.s = { alignment: { horizontal: "center" }, border: cellTable };
        }
      }
      let fmt = "#,##0.00";
      let range = { s: { r: 4, c: 1 }, e: { r: 16, c: 4 } };
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell && R === 16)
            cell.s = {
              font: { bold: true },
              border: cellTable,
              alignment: { horizontal: "center" },
            };
          else if (cell) cell.s = { border: cellTable };
          if (!cell || cell.t != "n") continue;
          cell.z = fmt;
          if (R === 16) cell.s = { font: { bold: true }, border: cellTable };
          else cell.s = { border: cellTable };
        }
      }
      ws["!cols"] = [
        { wch: 10 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];
      let wsrows = [];
      for (let i = 1; i <= 14; i++) wsrows.push({ hpt: 20 });
      ws["!rows"] = wsrows;
      ws["!merges"] = [{ s: { r: 16, c: 0 }, e: { r: 16, c: 1 } }];
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      XLSX.utils.sheet_add_aoa(ws, [[userProfile?.company_name || ""]], {
        origin: "A1",
      });
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(
        data,
        "report_" + year + "_" + currFileName + fileExtension,
      );
      setLoading(false);
    }, 1400);
  }

  return (
    <Layout>
      <Loading isLoading={isLoading} />
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
        <div className="text-center mt-2 mb-4">
          <strong className="text-lg text-gray-900">
            รายงานสรุปรายรับ-รายจ่าย
          </strong>
        </div>

        <div className="flex items-center gap-3 mb-4">
          <strong className="text-sm text-gray-700">เลือก ปี พ.ศ.</strong>
          <select
            className={`${inputClass} w-32`}
            onChange={onChangeYear}
            value={year}
          >
            <option value="">ปี พ.ศ.</option>
            {rangeYears.map((year: any, index: number) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        <div className="overflow-x-auto border border-gray-200 rounded-lg">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-rose-100/50 border-b border-rose-200">
                <th className="px-3 py-2.5 text-center font-semibold text-gray-700">
                  เดือน
                </th>
                <th className="px-3 py-2.5 text-right font-semibold text-gray-700">
                  ยอดรายรับ
                </th>
                <th className="px-3 py-2.5 text-right font-semibold text-gray-700">
                  ยอดรายจ่าย
                </th>
                <th className="px-3 py-2.5 text-right font-semibold text-gray-700">
                  กำไรสุทธิ
                </th>
              </tr>
            </thead>
            <tbody>
              {reportMonths.map((rm, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-100 hover:bg-gray-50"
                >
                  <td className="px-3 py-2 text-center whitespace-nowrap">
                    {rm.month_name}
                  </td>
                  <td className="px-3 py-2 text-right whitespace-nowrap">
                    {convertToFormat(rm.sum_income)}
                  </td>
                  <td className="px-3 py-2 text-right whitespace-nowrap">
                    {convertToFormat(rm.sum_expense)}
                  </td>
                  <td className="px-3 py-2 text-right whitespace-nowrap">
                    {convertToFormat(rm.net_profit)}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-50 border-t-2 border-gray-300">
                <td className="px-3 py-2.5 text-center font-bold">
                  สรุปยอดรวมปี {year}
                </td>
                <td className="px-3 py-2.5 text-right font-bold">
                  {convertToFormat(sumYearIncome)}
                </td>
                <td className="px-3 py-2.5 text-right font-bold">
                  {convertToFormat(sumYearExpense)}
                </td>
                <td className="px-3 py-2.5 text-right font-bold">
                  {convertToFormat(sumYearNetProfit)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <p className="text-xs text-gray-400 mt-2">
          *** คำนวณเฉพาะรายการที่ขายแล้ว ** ยอดของเดือนเป็นยอดตามวันที่ขายออก
        </p>

        <div className="flex justify-end mt-3">
          <Button
            variant="dark"
            size="lg"
            icon={<FcExport size="18" />}
            onClick={exportToExcel}
          >
            Export Excel
          </Button>
        </div>
      </div>
    </Layout>
  );
}

export default Report;
